/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingLandingConfig } from '../../config/loading.config';

export interface IStaticContentPluginMethods extends IPluginMethodMap {
  getStaticContentSync(args?: any): any;
}

export class StaticContentPlugin implements IAgentPlugin {
  readonly methods: IStaticContentPluginMethods;

  constructor() {
    this.methods = {
      getStaticContentSync: this.getStaticContentSync.bind(this),
    };
  }

  getStaticContentSync(args?: any) {
    return {
      loading: loadingLandingConfig,
    };
  }
}
